<template>
    <b-container class="w-100 p-0 m-0" ref="modelViewerContainer">
        <b-container class="w-100" style="width: 100%;" >
            <b-row class="justify-content-center align-items-center">
                <b-col sm=0 cols=1 v-show="viewerLoader">
                    <b-spinner class="vertical-center" ></b-spinner>
                </b-col>
                <b-col sm=0 cols=12 v-show="!viewerLoader">
                    <b-container ref="modelshow" ></b-container>
                </b-col>
            </b-row>
        </b-container>
    </b-container>
</template>

<script>
import ModelViewer from '../../services/webgl.service'
import {getModel} from '../../services/api.service';

export default {
    name: "ViewModel",
    props: ['guid', 'format'],
    data() {
        return {
            viewerLoader: true
        }
    },
    methods: {
        setSize() {
            var clientSize = window.innerWidth;
            var size = 700;
            if (clientSize > 1200)
                size = 700
            if (clientSize > 575 && clientSize < 992)
                size = 400
            if (clientSize < 576)
                size = clientSize-100
            return size;
        }
    },
    mounted () {
        this.viewerLoader = true;
        var size = this.setSize();
        this.modelViewer = new ModelViewer(size, size, true);
        this.$AuthService.getAccessToken(function() {
            getModel(this.guid, this.$AuthService.token.accessToken)
            .then(function(data) {
                var renderer = this.modelViewer.loadFile(window.URL.createObjectURL(data), this.format)
            
                this.$nextTick(function() {
                var modelshow = this.$refs.modelshow
                modelshow.appendChild(renderer);
                this.viewerLoader = false;
                }.bind(this))
            }.bind(this))
        }.bind(this))
    }
}
</script>